import styled from 'styled-components';
import background from '../../assets/products/shopBackground.jpg'
import { colors } from "../../utils/colors";

export const Background = styled.div`
    position: relative;
    width: 100%;
    min-height: 100vh;
    background: url(${background});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const AllProductsTitle = styled.h1`
    color: ${colors.WHITE};
`;

export const TittleWrapper = styled.div`
    text-align: center;
    padding: 0 20px;
    width: 100%;
    max-width: 1200px;
    margin: 150px auto 30px;
    position: relative;
`;

export const CreamTitle = styled.span`
    color: ${colors.CREAM};;
`;

export const AllProductsWrapper = styled.div`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto 100px;
    padding: 0 20px;
`;

export const CategoryButtonWrapper = styled.div`
    display: flex;

    @media (max-width: 800px) {
       flex-direction: column;
       width: 90%;
       margin: 0 auto;
    }
`;

export const FilterButton = styled.button`
    border: 2px solid ${colors.CREAM};
    margin: 0 5px 25px 5px;
    padding: 5px 10px;
    background: ${(props) => props.active ? colors.CREAM : 'transparent'};
    border-radius: 5px;
    color: ${(props) => props.active ? colors.BLUE : 'white'};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1);
    text-transform: uppercase;

    &:hover {
        cursor: pointer;
        border: 2px solid ${colors.BLUE};
        background: ${colors.CREAM};
    }
`;

export const FilterButtonWrapper = styled.div`
    height: 75px;
    display: flex;
    color: ${colors.RED};

    @media (max-width: 800px) {
       flex-direction: column;
       width: 90%;
       margin: 0 auto;
    }
`;